import { require_jsx_runtime as e } from "./index21.js";
import { CssBaseline as t, GlobalStyles as n } from "@mui/material";
//#region src/components/ResetCSS.tsx
var r = e(), i = () => /* @__PURE__ */ (0, r.jsxs)(r.Fragment, { children: [/* @__PURE__ */ (0, r.jsx)(t, {}), /* @__PURE__ */ (0, r.jsx)(n, { styles: {
	"input[type=\"search\" i]::-webkit-search-cancel-button": { display: "none" },
	"a:-webkit-any-link": { WebkitTapHighlightColor: "transparent" }
} })] });
//#endregion
export { i as ResetCSS };

//# sourceMappingURL=index608.js.map